import { render, staticRenderFns } from "./Arima.vue?vue&type=template&id=4185eb75&scoped=true&"
import script from "./Arima.vue?vue&type=script&lang=js&"
export * from "./Arima.vue?vue&type=script&lang=js&"
import style0 from "./Arima.vue?vue&type=style&index=0&id=4185eb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185eb75",
  null
  
)

export default component.exports